class MathBest {
    constructor(amount: number, set: number[]) {
        this.rest = amount;
        this.set = set;
    }

    rest: number;
    set: number[];
    output: {[k: number]: number} = {}
}
interface Event {
    stop(): void;
    data: string | null;
}
interface Math {
    gcf(a: number, b: number): number;
    lcm(a: number, b: number): number;
    getBest(input: MathBest): MathBest;
    roundPlaces(a: number, b: number): number;
}
Event.prototype.stop = function() {
    this.preventDefault();
    this.stopPropagation();
}
///Greatest Common Factor
Math.gcf = function(a: number, b: number) {
    while (b != 0) {
        let temp = b;
        b = a % b;
        a = temp;
    }
    return a;
}
///Least Common Multiple
Math.lcm = function(a: number, b: number) {
    return (a / Math.gcf(a, b)) * b;
}
Math.getBest = function(input: MathBest) {
    input.output = input.output ? input.output : {};

    let divider = input.set.shift();
    if(divider === undefined)
        return input;
    
    let count = Math.floor(input.rest / divider);

    if (input.set.length > 0) {
        while (count >= 0) {
            let sub = Math.getBest(
            {
                rest: input.rest - (divider * count),
                output: input.output,
                set: input.set.slice(0)
            });
            if (sub.rest == 0) {
                input.rest = 0;
                break;
            }
            count--;
        }
    }
    else {
        input.rest = input.rest - (divider * count);
    }

    if (input.rest == 0) {
        input.output[divider] = count;
    }
    return input;
}
Math.roundPlaces = function(number: number, places: number) {
    const multiplier = Math.pow(10, places);
    return Math.round(number * multiplier + Number.EPSILON) / multiplier;
}